import "./signin.scss";
import { inject, observer } from "mobx-react";

import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import PhoneInputField from "sharedComponents/PhoneInputField";

import cross from "images/cross.svg";

import { validationPhone } from "../../Validation/index";

const NewPassword = ({
  passwordReset,
  cleanErrorRegistration,
  errorRegistration,
  setNewPasswordModal,
  setSignInWithNewPasswordModal,
  ...props
}) => {
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="signin">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={() => {
              setNewPasswordModal(false);
              cleanErrorRegistration();
            }}
            alt=""
          />
        </p>
        <Formik
          initialValues={{
            phone: ""
          }}
          validateOnBlur
          onSubmit={async (values) => {
            const ok = await passwordReset(values);
            if (ok) {
              cleanErrorRegistration();
              setSignInWithNewPasswordModal(true);
              setNewPasswordModal(false);
            }
          }}
          validationSchema={validationPhone}
        >
          {({ isValid, handleSubmit, dirty }) => (
            <div className="signin-form">
              <Form>
                <p className="registration-form-title">
                  Восстановление пароля{" "}
                </p>

                <div className="p-2 col-example text-left mb-3">
                  <PhoneInputField
                    name="phone"
                    title="Введите ваш номер телефона"
                  />
                </div>

                <div>
                  <button
                    className="signin-btn"
                    type="submit"
                    disabled={!isValid || !dirty}
                    onClick={handleSubmit}
                  >
                    Отправить
                  </button>
                </div>

                {errorRegistration ? (
                  <p className="signin-form-error">{errorRegistration}</p>
                ) : null}
              </Form>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, modalWindows }) => {
  const { passwordReset, cleanErrorRegistration, errorRegistration } =
    usersStore;
  const { setNewPasswordModal, setSignInWithNewPasswordModal } = modalWindows;

  return {
    passwordReset,
    cleanErrorRegistration,
    errorRegistration,

    setNewPasswordModal,
    setSignInWithNewPasswordModal
  };
})(observer(NewPassword));
